import TitanIntroText from "./TitanIntroText";
import TitanPeriods from "./TitanPeriods";
import TitanCashGamesInfo from "./TitanCashGamesInfo";
import TitanRules from "./TitanRules";

const COMPONENT_MAP = {
  IntroText: TitanIntroText,
  Periods: TitanPeriods,
  CashGamesInfo: TitanCashGamesInfo,
  Rules: TitanRules,
};

export default COMPONENT_MAP;
